import { armarParametros } from '../helpers/armarParametros';
import { fetchConToken, fetchConTokenMultipleFile } from '../helpers/fetch';
import { armarParametrosGetComprobantesDocumentoRemito, armarParametrosGetComprobantesRemito } from '../helpers/parametros';
import { DATOS_COMPROBANTE, DATOS_EXPEDIENTE } from '../utils/constants';

const MesaEntradaService = {
  // Comprobantes Recepcion
  getComprobantesDocumento: (tipoComprobanteDocumento) => {
    return fetchConToken(
      `MesaEntrada/ComprobantesDocumento/${tipoComprobanteDocumento}`,
    );
  },
  getComprobantesPrestadores: (idEfectorFacturacion) => {
    return fetchConToken(
      `MesaEntrada/ComprobantesPrestadores/${idEfectorFacturacion}`,
    );
  },
  getComprobantesProformas: (id) => {
    return fetchConToken(`MesaEntrada/ComprobanteProforma/${id}`);
  },

  // Comprobantes Gestion
  getComprobantesDocumentoGestion: (parametros) => {
    return fetchConToken(
      `MesaEntrada/traerGestionComprobantesDocumento?${parametros}`,
    );
  },
  getComprobantesPrestadoresGestion: (parametros) => {
    return fetchConToken(
      `MesaEntrada/traerGestionComprobantesPrestadores?${parametros}`,
    );
  },
  getComprobantesDocumentoGestionBuscador: (parametros) => {
    return fetchConToken(
      `MesaEntrada/traerGestionComprobantesDocumento/Buscador?${parametros}`,
    );
  },
  getComprobantesPrestadoresGestionBuscador: (parametros) => {
    return fetchConToken(
      `MesaEntrada/traerGestionComprobantesPrestadores/Buscador?${parametros}`,
    );
  },
  getComprobantesOspeDirectoBuscador: (parametros) => {
    return fetchConToken(
      `MesaEntrada/traerComprobantesOspeDirecto/${armarParametros(parametros)}`,
    );
  },
  confirmComprobantesOspeDirecto: (data) => {
    return fetchConToken(
      `MesaEntrada/ConfirmarExpediente/OspeDirecto`, data, "PUT",
    );
  },
  rechazarComprobantesOspeDirecto: (id, motivo) => {
    return fetchConToken(
      `MesaEntradaDirecto/Comprobante/${id}?motivo=${motivo}`, {}, "DELETE",
    );
  },
  getBuscadorMesaEntrada: (parametros) => {
    return fetchConToken(
      `MesaEntrada/buscadorMesaEntradas?${parametros}`,
    );
  },
  // Comprobantes CRUD
  postComprobanteDocumento: (data) => {
    return fetchConToken(`MesaEntrada/ComprobantesDocumento`, data, 'POST');
  },
  postComprobantePrestadores: (data) => {
    return fetchConToken(`MesaEntrada/Comprobantes`, data, 'POST');
  },
  deleteComprobante: (idExpediente, data) => {
    return fetchConToken(`MesaEntrada/${idExpediente}`, data, 'DELETE');
  },
  updateComprobante: (data) => {
    return fetchConToken(
      `MesaEntrada/ModificacionDestinoExpedientes`,
      data,
      'PUT',
    );
  },
  updateEstadoComprobante: (data, retornar) => {
    return fetchConToken(
      `MesaEntrada/EditarEstadoExpediente?&retornarExpediente=${retornar}`,
      data,
      'PUT',
    );
  },

  // Datos Comprobante
  getTipoComprobante: () =>
    fetchConToken(
      `MesaEntrada/DatosComprobante/${DATOS_COMPROBANTE.TIPO_COMPROBANTE}`,
    ),
  getTipoFactura: () =>
    fetchConToken(
      `MesaEntrada/DatosComprobante/${DATOS_COMPROBANTE.TIPO_FACTURA}`,
    ),
  getProcedencia: () =>
    fetchConToken(
      `MesaEntrada/DatosComprobante/${DATOS_COMPROBANTE.PROCEDENCIA}`,
    ),
  getDestinos: () =>
    fetchConToken(`MesaEntrada/DatosExpediente/${DATOS_EXPEDIENTE.DESTINO}`),
  getSolic: (idSolic, periodo, idEfectorFacturacion, idTramite) =>
    fetchConToken(
      `MesaEntrada/ComprobanteIntegracion/${idSolic}/${periodo}/${idEfectorFacturacion}/${idTramite}`,
    ),
  getUsuarioLiquidacion: (idEfectorFacturacion) =>
    fetchConToken(`MesaEntrada/UsuarioLiquidaciones/${idEfectorFacturacion}`),

  getTramites: () => fetchConToken(`MesaEntrada/Tramites`),
  putTramite: (data) =>
    fetchConToken(`MesaEntrada/TramitesDestinos`, data, 'PUT'),

  /* TRACKING - TRAMITES/DESTINOS */
  getTrackingTramitesDestinos: (id) =>
    fetchConToken(`MesaEntrada/TrackingTramitesDestinos/${id}`),

  // Documentacion
  getDocumentacion: (idExpediente) => {
    return fetchConToken(`MesaEntradaDocumentacion/${idExpediente}`);
  },
  getDocumentacionDirecto: (idExpediente) => {
    return fetchConToken(`MesaEntradaDocumentacion/Documentacion/${idExpediente}`);
  },
  postDocumentacion: (file, idTipoDoc, idExpediente, dispatch) => {
    return fetchConTokenMultipleFile(
      `MesaEntradaDocumentacion/${idTipoDoc}/${idExpediente}`,
      file
    );
  },
  deleteDocumentacion: (idDocumentacionComprobante) => {
    return fetchConToken(
      `MesaEntradaDocumentacion/${idDocumentacionComprobante}`,
      {},
      'DELETE',
    );
  },
  getExcelComprobantesPrestadores: (idEfectorFacturacion) => {
    return fetchConToken(
      `MesaEntrada/GenerarExcelComprobante/${idEfectorFacturacion}`,
    );
  },
  getExcelComprobantesDocumento: (tipoComprobanteDocumento) => {
    return fetchConToken(
      `MesaEntrada/GenerarExcelComprobantesDocumento/${tipoComprobanteDocumento}`,
    );
  },
  getExcelComprobantesGestion: (idEstado, parametros) => {
    return fetchConToken(
      `MesaEntrada/GenerarExcelComprobanteGestion/${idEstado}?${parametros}`,
    );
  },
  getPdfComprobantesPrestadores: (idEfectorFacturacion) => {
    return fetchConToken(
      `MesaEntrada/GenerarPDFComprobante/${idEfectorFacturacion}`,
    );
  },
  getPdfComprobantesDocumento: (tipoComprobanteDocumento) => {
    return fetchConToken(
      `MesaEntrada/GenerarPDFComprobantesDocumento/${tipoComprobanteDocumento}`,
    );
  },
  getExcelComprobantesDocumentoGestion: (idEstado, parametros) => {
    return fetchConToken(
      `MesaEntrada/GenerarExcelComprobanteDocumentoGestion/${idEstado}?${parametros}`,
    );
  },
  getComprobantesRemitos: (
    fechaDesde,
    fechaHasta,
    idTipoIngreso, 
    generado,
    idArea, 
    idSubArea
    ) => {
      
    return fetchConToken(
      `MesaEntrada/RemitosComprobantes?
        ${armarParametrosGetComprobantesRemito(
          fechaDesde,
          fechaHasta,
          idTipoIngreso,
          generado,
          idArea, 
          idSubArea
        )
      }`
    );
  },
  getComprobantesDocumentoRemitos: (
    fechaDesde,
    fechaHasta,
    idTipoIngreso, 
    generado,
    idArea, 
    idSubArea
    ) => {
      
    return fetchConToken(
      `MesaEntrada/RemitosComprobantesDocumento?
        ${armarParametrosGetComprobantesDocumentoRemito(
          fechaDesde,
          fechaHasta,
          idTipoIngreso,
          generado,
          idArea, 
          idSubArea
        )
      }`
    );
  },
  generarRemitoMesa: (data) => {
    return fetchConToken(`MesaEntrada/GenerarRemito`, data, 'POST');
  },

};

export default MesaEntradaService;



